import { createFileRoute, redirect } from "@tanstack/react-router";

import { ConsoleEmbeddedIdentityPage, consoleContextQueryOptions } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/embedded-identity")({
  validateSearch: (search: Record<string, unknown>) => ({
    capability: search.capability === "email" || search.capability === "drive" || search.capability === "chat" || search.capability === "calendar" ? search.capability : undefined,
    ando_status: typeof search.ando_status === "string" ? search.ando_status : undefined,
    ando_session: typeof search.ando_session === "string" ? search.ando_session : undefined,
    ando_proof: typeof search.ando_proof === "string" ? search.ando_proof : undefined,
    app_id: typeof search.app_id === "string" ? search.app_id : undefined,
    section: search.section === "users" || search.section === "settings" || search.section === "test" || search.section === "oidc" ? search.section : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (search.section === "settings" || search.section === "test" || search.section === "oidc" || (search.app_id && search.ando_status)) {
      throw redirect({
        to: "/console/apps",
        search: {
          app_id: search.app_id,
          section: search.section === "settings" || search.section === "oidc" ? search.section : "test",
          ando_status: search.ando_status,
          ando_session: search.ando_session,
          ando_proof: search.ando_proof,
        },
        replace: true,
      });
    }
  },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(consoleContextQueryOptions()),
  component: ConsoleEmbeddedIdentityPage,
});
